/**
 * bootstrap 4 breakpoints
 * @see https://github.com/twbs/bootstrap/blob/v4-dev/scss/_variables.scss#L183
 */
export const BREAKPOINTS = {
  XS: 0,
  SM: 576,
  MD: 768,
  LG: 992,
  XL: 1200
};



// WEBPACK FOOTER //
// ./javascript/constants.js